module.exports = __webpack_public_path__ + "static/img/jianjiePic.a4632ece.png";